import {
  Button,
  Fade,
  FormControl,
  IconButton,
  Menu,
  MenuItem,
  Popper,
  TextField,
} from "@material-ui/core";
import styled, { createGlobalStyle, keyframes } from "styled-components";
import { Link } from "react-router-dom";
import { Colors } from "./statics";
import { hexToRgbA } from "../commons/utils";

export const GlobalStyle = createGlobalStyle`
  body {
    /* overflow: overlay; */
    background-color: ${Colors.darkBg};
  }
  * {
    outline: none!important;
    margin: 0;
    padding: 0;
    font-family: 'Mulish', sans-serif;
    box-sizing: border-box;
    /* font-weight: normal; */
    /* line-height: 1; */
  }
  a, a:hover {
    text-decoration: none;
  }
  ul {
    list-style: none;
  }
  img {
    width: 100%;
  }
  svg {
    /* min-width: fit-content!important; */
    /* width: intrinsic!important; ; */
    display: table;
  }
  ::-webkit-scrollbar{
    width: 10px;
    height: 6px;
  }
  ::-webkit-scrollbar-thumb{
    background: ${Colors.grey};
    border-radius: 0px;
    border-radius: 8px;
  }
  ::-webkit-scrollbar-thumb:hover{
    background: ${Colors.purple};
  }
  ::-webkit-scrollbar-track{
    background:  ${Colors.lightGrey};
    border-radius: 10px;
    box-shadow: inset 0px 0px 0px 0px  ${Colors.lightGrey};
  }
  .MuiOutlinedInput-root {
    border-radius: 0px;
  }
  .MuiInput-underline {
    input, textarea {
      color: ${Colors.ligthWhite};
    }
    :before {
      border-bottom: 1px solid ${Colors.darkWhite};
    }
    .MuiSelect-select.MuiSelect-select {
      padding-right: 24px;
      color: ${Colors.ligthWhite};
    }
  }
  .MuiFormLabel-root {
    color: ${Colors.darkWhite};
    white-space: nowrap;
  }
  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline { // input border
    border-color: ${Colors.purple};
    border-radius: 8px;
  }
  .MuiOutlinedInput-notchedOutline {
    border-radius: 8px;
  }
  .MuiInput-underline:after, .MuiInput-underline.Mui-focused:after {
    border-color: ${Colors.purple};
  }
  .MuiInput-underline:hover:not(.Mui-disabled):before {
    border-color: ${Colors.darkWhite};
  }
  .MuiPopover-paper {
    background: ${Colors.darkLightBg};
    padding: 0 5px;
  }
  .MuiAutocomplete-popper {
    * {
      color: ${Colors.white};
    }
  }
  .MuiTooltip-popper {
    font-size: 16px;
    color: ${Colors.white};
    * {
      color: ${Colors.white};
      font-size: 16px;
    }
  }
  .MuiMenuItem-root {
    color: ${Colors.grey};
  }
  #tableButton {
    display: flex;
    height: 45px;
    width: 43px; // temp
    > * {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      /* z-index: 1; */
      /* width: 24px; */
      width: inherit;
      /* height: 30px; */
      /* height: inherit; */
      height: 55px;
      right: 1px;
      background-color: ${Colors.darkSemiBg};
      border-left: 1px solid ${Colors.grey};
      /* border-bottom: 1px solid ${Colors.lightGrey}; */
      border-radius: 0;
      transform: translate(0, -5px);
    }
    svg {
      fill: ${Colors.ligthWhite}
    }
  }
  .MuiFormLabel-root.Mui-disabled {
    color: ${Colors.darkWhite};
    opacity: 0.5;
  }
  span.MuiTypography-root.MuiFormControlLabel-label.MuiTypography-body1 {
    color: ${Colors.darkWhite};
  }
  .MuiInputBase-input.Mui-disabled {
    opacity: 0.5;
  }
  .MuiSwitch-colorPrimary {
    color: ${Colors.purple};
    &.Mui-checked {
      color: ${Colors.purple};
    }
    &.Mui-checked + .MuiSwitch-track {
      background-color: ${Colors.purple};
    }
  }
  .MuiSwitch-colorSecondary {
    color: ${Colors.orange};
    &.Mui-checked {
      color: ${Colors.orange};
      :hover {
        background-color: ${hexToRgbA(Colors.purple, 0.2)}
      }
    }
    &.Mui-checked + .MuiSwitch-track {
      background-color: ${Colors.orange};
    }
  }
  .MuiPaper-root {
    background-color: ${Colors.darkSemiBg};
  }
  .MuiCheckbox-root {
    color: ${Colors.darkWhite};
  }
  .MuiIconButton-colorSecondary {
    color: ${Colors.darkWhite};
    &.Mui-checked {
      color: ${Colors.purple};
    }
    :hover {
      background-color: ${hexToRgbA(Colors.purple, 0.1)}
    }
  }
  .MuiListItemText-root {
    color: ${Colors.darkWhite};
  }
  .MuiSelect-icon {
    color: ${Colors.purple};
    &.Mui-disabled {
      color: ${Colors.darkLightBg};
    }
  }
  .fileInputWrapper {
    position: relative;
    input {
      padding-right: 115px;
    }
    .MuiButtonBase-root {
      position: absolute;
      right: 0;
      bottom: 5px;
    }
  }
  .MuiSvgIcon-colorPrimary {
    color: ${Colors.darkWhite}!important;
  }
  .DraftEditor-editorContainer {
    min-height: 500px;
  }
`;

export const Simplelink = styled(Link)`
  display: inline-block;
  color: ${Colors.dark};
  transition: all 0.3s ease;
  user-select: none;
  font-weight: 600;
  :hover {
    color: ${Colors.dark};
  }
`;

export const CustomButton = styled(Button)`
  background-color: ${Colors.purple};
  color: ${Colors.white};
  text-transform: none;
  padding: 10px 30px;
  height: 35px;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 6px;
  &.Mui-disabled {
    color: ${Colors.darkWhite}!important;
  }
  :hover {
    background-color: ${(props) =>
      props.light
        ? Colors.blueLight
        : props.white
          ? Colors.White
          : hexToRgbA(Colors.purple, 0.7)};
    color: ${(props) => (props.light ? Colors.blue : Colors.white)};
  }
  ${(props) =>
    props.simple &&
    `
    background-color: transparent;
    color: ${Colors.lightBlack};
    :hover {
      background-color: transparent;
      color: ${Colors.lightBlack};
    }
  `}
  ${(props) =>
    props.lined &&
    `
    background-color: transparent;
    color: ${Colors.darkWhite};
    border: 1px solid ${Colors.darkWhite};
    :hover {
      background-color: transparent;
      color: ${Colors.darkWhite};
    }
  `}
  ${(props) =>
    props.lightBlack &&
    `
    background-color: ${hexToRgbA(Colors.lightBlack, 0.9)};
    color: ${Colors.white};
    // font-size: 18px;
    // line-height: 20px;
    :hover {
      background-color: ${Colors.lightBlack};
      color: ${Colors.white};
    }
  `}
  ${(props) =>
    props.dark &&
    `
    background-color: ${hexToRgbA(Colors.dark, 0.9)};
    color: ${Colors.white};
    // font-size: 18px;
    // line-height: 20px;
    :hover {
      background-color: ${Colors.dark};
      color: ${Colors.white};
    }
  `}
  ${(props) =>
    props.lightBlue &&
    `
    background-color: ${hexToRgbA(Colors.blueLight, 0.5)};
    color: ${Colors.blue};
    :hover {
      background-color: ${Colors.blueLight};
      color: ${Colors.blue};
    }
  `}
   ${(props) =>
    props.darkGrey &&
    `
    background-color: ${hexToRgbA(Colors.grey, 1)};
    color: ${Colors.white};
    :hover {
      background-color: ${Colors.lightBlack};
      color: ${Colors.white};
    }
  `}
  ${(props) =>
    props.purple &&
    `
    background-color: ${Colors.purple};
    color: ${Colors.white}!important;
    :hover {
      background-color: ${hexToRgbA(Colors.purple, 0.7)};
      color: ${Colors.white};
    }
  `}
  ${(props) =>
    props.orange &&
    `
    background-color: ${Colors.lightOrange};
    color: ${Colors.lightBlack};
    :hover {
      background-color: ${Colors.lightOrange};
      color: ${Colors.lightBlack};
    }
  `}
  ${(props) =>
    props.red &&
    `
    background-color: ${Colors.burgundy};
    color: ${Colors.white};
    :hover {
      background-color: ${Colors.burgundy};
      color: ${Colors.white};
    }
  `}
  ${(props) =>
    props.grey &&
    `
    background-color: ${Colors.lightGrey};
    color: ${Colors.lightBlack};
    &.MuiButton-root.Mui-disabled {
      color: ${hexToRgbA(Colors.lightBlack, 0.8)};
    }
    :hover {
      background-color: ${Colors.lightGrey};
      color: ${Colors.lightBlack};
    }
  `}
  ${(props) =>
    props.semiLightGrey &&
    `
    background-color: ${Colors.semiLightGrey};
    color: ${Colors.lightBlack};
    :hover {
      background-color: ${Colors.lightGrey};
      color: ${Colors.lightBlack};
    }
  `}
  ${(props) =>
    props.pink &&
    `
    background-color: ${hexToRgbA(Colors.pink, 0.5)};
    color: ${Colors.burgundy};
    :hover {
      background-color: ${hexToRgbA(Colors.pink, 0.5)};
      color: ${Colors.burgundy};
    }
  `}
  ${(props) =>
    props.white &&
    `
    background-color: ${Colors.white};
    color: ${Colors.lightBlack};
    border: 1px solid ${Colors.lightBlack};
    :hover {
      background-color: ${Colors.white};
      color: ${Colors.lightBlack};
    }
  `}
  ${(props) =>
    props.yellow &&
    `
    background-color: ${Colors.yellow};
    color: ${Colors.lightBlack};
    :hover {
      background-color: ${Colors.yellow};
      color: ${Colors.lightBlack};
    }
  `}
  ${(props) =>
    props.large &&
    `
    height: unset;
    padding: 20px 40px;
    border-radius: 14px;
    font-size: 18px;
  `}
`;

export const CustomIconButton = styled(IconButton)`
  color: ${Colors.darkWhite};
  svg {
    /* fill: ${Colors.dark}; */
  }
  * {
    border-radius: 5px;
  }
  &.MuiIconButton-root {
    border-radius: 5px;
  }
  ${(props) =>
    props.noPad &&
    `
    &.MuiIconButton-root {
      padding: 0;
    }
  `}
`;

export const CustomFormControl = styled(FormControl)`
  > label {
    font-size: 20px;
    color: ${(props) => props.theme.text1};
    font-weight: 600;
  }
  .MuiAutocomplete-tag {
    color: ${Colors.blueBlack2};
    border-radius: 10px;
    background: ${Colors.error};
    font-weight: 600;
    .MuiChip-deleteIcon {
      fill: ${hexToRgbA(Colors.blueBlack2, 0.3)};
      :hover {
        fill: ${hexToRgbA(Colors.blueBlack2, 0.6)};
      }
    }
  }
  .MuiInputBase-root {
    color: ${(props) => props.theme.text2};
    border-radius: 5px;
    background: ${(props) => props.theme.inputBackg};
    padding: 0;
    max-height: 190px;
    /* overflow: auto; */
    overflow: hidden;
    min-height: 38px; // temp
  }
  .MuiInputLabel-outlined.MuiInputLabel-shrink {
    transform: translate(15px, -25px) scale(0.75);
  }
  .MuiOutlinedInput-notchedOutline {
    border-color: ${(props) => props.theme.inputBorder};
    border-width: 1px;
    border-style: solid;
  }
  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${(props) => props.theme.inputBorder};
  }
  .MuiOutlinedInput-root.Mui-focused,
  .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border-color: ${(props) => props.theme.inputBorder};
  }
  ${(props) =>
    props.error &&
    `
    .MuiOutlinedInput-notchedOutline {
      border-color: ${Colors.red}!important;
    }
  `}
`;

export const CustomFileText = styled(TextField)`
  ${(props) =>
    props.disabled &&
    `
    .MuiOutlinedInput-notchedOutline {
      border-color: rgba(184, 200, 219, .6);
      border-width: 1px;
      border-style: solid;
    }
    .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: rgba(184, 200, 219, .6);
    }
    .MuiOutlinedInput-root.Mui-focused, .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
      border-color: rgba(184, 200, 219, .6);
    }
    .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline {
      border-color: rgba(184, 200, 219, .6);
    }
  `}
`;

export const CustomMenuItem = styled(MenuItem)`
  ${(props) =>
    props.active &&
    `
    color: #2144D4;
    svg {
      path {
        fill: #2144D4;
      }
      circle {
        fill: #2144D4;
      }
      rect {
        fill: #2144D4;
      }
    }
  `}
`;

export const TabbleStatusBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  background: ${(props) =>
    props.status === 0
      ? hexToRgbA(Colors.warning, 0.1)
      : props.status === 1
        ? hexToRgbA(Colors.lightBlue, 0.1)
        : props.status === 2
          ? hexToRgbA(Colors.error, 0.1)
          : props.status === 3
            ? hexToRgbA(Colors.success, 0.1)
            : "red"};
  color: ${(props) =>
    props.status === 0
      ? Colors.warning
      : props.status === 1
        ? Colors.lightBlue
        : props.status === 2
          ? Colors.error
          : props.status === 3
            ? Colors.success
            : "red"};
  border: 1px solid;
  border-color: ${(props) =>
    props.status === 0
      ? hexToRgbA(Colors.warning, 0.7)
      : props.status === 1
        ? hexToRgbA(Colors.lightBlue, 0.7)
        : props.status === 2
          ? hexToRgbA(Colors.error, 0.7)
          : props.status === 3
            ? hexToRgbA(Colors.success, 0.7)
            : "red"};
  border-radius: 4px;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
`;

const pulse = keyframes`
  0% { opacity: 0.15; transform: scale(1); }
  50% { opacity: 0.25; transform: scale(1.05); }
  100% { opacity: 0.15; transform: scale(1); }
`;

export const SmallWidget = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: linear-gradient(
    145deg,
    ${Colors.darkLightBg},
    ${Colors.darkSemiBg}
  );
  border-radius: 24px;
  overflow: hidden;
  width: 100%;
  height: 100%;
  padding: 24px 30px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  position: relative;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);

  &:hover {
    transform: translateY(-5px);
    border-color: ${(props) => props.accentColor || "#00F2FF"};
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.3);
    &::after {
      opacity: 0.3;
    }
  }

  &::after {
    content: "";
    position: absolute;
    top: -20%;
    right: -10%;
    width: 150px;
    height: 150px;
    background: ${(props) => props.accentColor || "#00F2FF"};
    filter: blur(50px);
    opacity: 0.15;
    z-index: 0;
    pointer-events: none;
    animation: ${pulse} 4s infinite ease-in-out;
  }

  .content {
    z-index: 1;
    h6 {
      font-size: 13px;
      font-weight: 600;
      color: rgba(255, 255, 255, 0.5);
      margin: 0;
      padding-bottom: 6px;
      text-transform: uppercase;
      letter-spacing: 1.2px;
    }
    h5 {
      font-size: 24px;
      font-weight: 800;
      color: ${Colors.lightWhite};
      margin: 0;
      letter-spacing: -0.5px;
      /* Sayıların daha belirgin olması için hafif text-shadow */
      text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    }
  }

  @media (max-width: 768px) {
    padding: 20px;
    h5 {
      font-size: 19px;
    }
  }
`;

export const MiddleWidget = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 28px;
  background-color: ${Colors.darkLightBg};
  padding: 28px;
  border: 1px solid rgba(255, 255, 255, 0.03);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);

  .header {
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    padding-bottom: 15px;
    margin-bottom: 20px;
  }
`;

export const MainWrapper = styled.div`
  /* padding: ${(props) => (props.activeUser ? "0 40px" : "0")}; */
  width: ${(props) => (props.sideOpen ? "100%" : "calc(100% - 250px)")};
  width: ${(props) => !props.singed && "100%"};
  margin-left: auto;
  transition: all 0.5s ease;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const PageWrapper = styled.div`
  width: 100%;
  min-height: calc(100vh - 74px);
  background-color: ${Colors.darkBg};
  overflow: hidden;
  padding: 40px;
  .pageHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: -5px;
    > * {
      margin: 5px;
      min-width: 100px;
    }
  }
  .filterButtons {
    margin: -5px;
    > * {
      margin: 5px;
    }
  }
  h1.title {
    font-weight: 600;
    font-size: 20px;
    line-height: 25px;
    /* color: ${Colors.dark}; */
    color: ${Colors.darkWhite};
    margin-bottom: 15px;
  }
`;

export const SidebarWrapper = styled.div`
  display: flex;
  min-width: ${(props) => (props.open ? 0 : 260)}px;
  max-width: ${(props) => (props.open ? 0 : 260)}px;
  height: 100vh;
  z-index: 100;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  background-color: ${Colors.darkSemiBg};

  @media (max-width: 768px) {
    min-width: 0px;
    max-width: 0px;
    position: absolute;
  }

  .leftFixed {
    display: flex;
    position: fixed;
    flex-direction: column;
    width: ${(props) => (props.open ? 0 : 260)}px;
    height: 100vh;
    background-color: ${Colors.darkSemiBg};
    border-right: 1px solid rgba(255, 255, 255, 0.05);
    padding: ${(props) => (props.open ? 0 : "20px 15px")};
    overflow: hidden;
    transition: all 0.4s ease;

    .logo {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100px;
      margin-bottom: 30px;
      svg {
        width: 160px;
        transition: opacity 0.3s;
        opacity: ${(props) => (props.open ? 0 : 1)};
      }
    }

    .navigator {
      display: flex;
      flex-direction: column;
      flex: 1;
      position: relative;
      gap: 4px;

      /* Aktif öğenin yanındaki dikey çizgi */
      .chosen {
        position: absolute;
        left: -15px;
        width: 4px;
        height: 44px;
        background-color: #00f2ff;
        border-radius: 0 4px 4px 0;
        box-shadow: 0 0 15px rgba(0, 242, 255, 0.6);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        z-index: 2;
      }
    }
  }
`;

export const SidebarItem = styled(Link)`
  display: flex;
  align-items: center;
  height: 44px; /* Sabit yükseklik */
  padding: 0 15px;
  text-decoration: none;
  border-radius: 12px;
  transition: all 0.3s ease;
  position: relative; /* Gösterge için gerekli */

  span {
    font-weight: 600;
    font-size: 15px;
    color: rgba(255, 255, 255, 0.5);
    padding-left: 12px;
    transition: all 0.2s;
  }

  svg {
    width: 22px;
    height: 22px;
    path,
    circle,
    rect {
      fill: rgba(255, 255, 255, 0.5);
      transition: all 0.2s;
    }
  }

  /* AKTİF DURUMU VE GÖSTERGE */
  ${(props) =>
    props.active &&
    `
    background-color: rgba(0, 242, 255, 0.08);
    
    span {
      color: #00F2FF;
    }

    svg path, svg circle, svg rect {
      fill: #00F2FF !important;
    }

  `}

  &:hover {
    background-color: rgba(255, 255, 255, 0.04);
    span {
      color: #fff;
    }
    svg path {
      fill: #fff;
    }
  }
`;

export const SidebarItemNotLink = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 40px;
  margin-bottom: 10px;
  user-select: none;
  transition: all 0.5s;
  width: 100%;
  padding-left: 15px;
  span {
    font-weight: 600;
    font-size: 18px;
    white-space: nowrap;
    padding-left: 15px;
    color: ${Colors.darkWhite};
    transition: all 0.5s;
  }
  &:last-of-type {
    transition: all 0.5s;
    margin-bottom: 0;
  }
  svg {
    width: 24px;
    height: 24px;
    min-width: 24px;
    path {
      fill: ${Colors.darkWhite};
    }
  }
  ${(props) =>
    props.active &&
    `
    span {
      color: ${Colors.ligthWhite};
    }
    svg path {
      fill: ${Colors.ligthWhite};
    }
  `}
  :hover {
    background-color: ${hexToRgbA(Colors.grey, 0.1)};
    border-radius: 15px;
    color: ${Colors.ligthWhite};
    span {
      color: ${Colors.ligthWhite};
    }
    svg path {
      fill: ${Colors.ligthWhite};
    }
  }
`;

export const HeaderWrapper = styled.div`
  height: 74px;
  .fixed {
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    height: 74px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;
    background-color: ${hexToRgbA(Colors.darkSemiBg, 0.9)};
    backdrop-filter: blur(10px); /* Modern cam efekti */
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    width: ${(props) => (props.sideOpen ? "100%" : "calc(100% - 260px)")};
    position: fixed;
    right: 0;
    z-index: 99;

    @media (max-width: 768px) {
      width: 100%;
      padding: 0 15px;
    }
  }

  .left {
    display: flex;
    align-items: center;
    gap: 15px;
    span {
      font-weight: 700;
      font-size: 18px;
      color: #fff;
      letter-spacing: 0.5px;
    }
    button {
      background: rgba(255, 255, 255, 0.03);
      border-radius: 10px;
      svg rect {
        fill: #00f2ff;
      } /* Hamburger rengi turkuaz */
    }
  }

  .right {
    display: flex;
    align-items: center;

    .profile {
      display: flex;
      align-items: center;
      padding: 5px 15px;
      background: rgba(255, 255, 255, 0.03);
      border-radius: 16px;
      border: 1px solid rgba(255, 255, 255, 0.05);
      transition: all 0.3s ease;
      cursor: pointer;

      &:hover {
        background: rgba(0, 242, 255, 0.05);
        border-color: rgba(0, 242, 255, 0.2);
      }

      .capitalNameBox {
        width: 40px;
        height: 40px;
        border-radius: 12px;
        background: linear-gradient(135deg, #00f2ff, #0061ff);
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 12px;
        box-shadow: 0 4px 10px rgba(0, 242, 255, 0.3);
        span {
          color: #fff;
          font-weight: 800;
          font-size: 14px;
        }
      }

      .name {
        h4 {
          font-weight: 700;
          font-size: 14px;
          color: #fff;
          margin-bottom: 2px;
        }
        p {
          font-size: 11px;
          font-weight: 600;
          color: #00f2ff;
          text-transform: uppercase;
          letter-spacing: 1px;
          opacity: 0.8;
        }
      }
    }
  }
`;

export const LoginWrapper = styled.div`
  width: 100%;
  height: 100vh;
  max-height: 100vh;
  /* background-color: ${Colors.purple}; */
  /* padding: 100px; */
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(${(props) => props.bg});
  background-repeat: no-repeat;
  background-position: right top;
  ::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-image: url(${(props) => props.bg});
    background-repeat: no-repeat;
    background-position: right top;
    transform: rotate(180deg);
    z-index: -1;
  }
  .right {
    width: 35%;
    min-width: 320px;
    max-height: 80vh;
    margin: auto;
    background: ${hexToRgbA(Colors.white, 0.7)};
    backdrop-filter: blur(10px);
    padding: 30px;
    border-radius: 15px;
    box-shadow: 0px 5px 30px -10px rgb(14 17 33);
    .logo {
      display: flex;
      justify-content: center;
      padding: 0;
    }
    > * {
      padding-top: 50px;
    }
    .form {
      > * + * {
        padding-top: 15px;
      }
    }
    .bottom {
      width: 100%;
      div {
        display: flex;
        width: 100%;
        padding-bottom: 10px;
        ${Simplelink} {
          display: flex;
          align-items: center;
          font-weight: 500;
          font-size: 16px;
          line-height: 25px;
          color: ${Colors.blue};
          margin-left: auto;
          :hover {
            color: ${Colors.purple};
          }
        }
      }
    }
  }
`;

export const SubSideMenuItem = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 10px 20px 20px;
  border-bottom: 1px solid ${Colors.greyBorder};
  width: 100%;
  cursor: pointer;
  user-select: none;
  transition: all 0.3s;
  :first-of-type {
    border-top: 1px solid ${Colors.greyBorder};
  }
  :hover {
    background-color: ${hexToRgbA(Colors.greyBorder, 0.7)};
    ::after {
      content: "";
      position: absolute;
      right: 1px;
      top: 0;
      bottom: 0;
      width: 2px;
      background-color: ${hexToRgbA(Colors.yellow, 0.5)};
    }
  }
  p {
    font-size: 16px;
    white-space: nowrap;
    padding-right: 5px;
    color: ${Colors.darkGrey};
  }
  svg {
  }
  ${(props) =>
    props.active &&
    `
    background-color: ${hexToRgbA(Colors.greyBorder, 0.9)};
    ::after {
      content: '';
      position: absolute;
      right: 1px;
      top: 0;
      bottom: 0;
      width: 2px;
      background-color: ${hexToRgbA(Colors.yellow, 0.8)};
    }
  `};
`;

export const SubSideMenu = styled.div`
  width: 250px;
  min-width: 250px;
  border: 1px solid ${Colors.greyBorder};
  .fixed {
    /* position: fixed;
    top: 74px; */
    h2 {
      font-size: 16px;
      line-height: 20px;
      font-weight: bold;
      text-align: center;
      padding: 30px;
    }
  }
`;

export const CustomFade = styled(Fade)`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  min-width: 35%;
  max-width: 400px;
  max-height: 90vh;
  padding: 35px 40px;
  border-radius: 15px;
  background-color: ${Colors.darkSemiBg};
  overflow: overlay;
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid ${Colors.lightGrey};
    padding-bottom: 10px;
    h1 {
      font-weight: 600;
      font-size: 20px;
      line-height: 25px;
      color: ${Colors.darkWhite};
    }
    svg {
      fill: ${Colors.darkWhite};
    }
  }
  .content {
    .form {
      > * {
        margin-top: 15px;
      }
    }
    .itemWrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      p {
        color: ${Colors.darkWhite};
      }
    }
    .similarIdeas {
      h2,
      h3 {
        text-align: center;
        padding-top: 10px;
        font-size: 16px;
        line-height: 17px;
      }
      h2 {
        font-weight: bold;
      }
    }
  }
  .dateWrapper {
    display: flex;
    flex-wrap: wrap;
    margin: -15px -10px !important;
    padding-top: 15px;
    > * {
      margin: 15px 10px;
      flex: 1;
      min-width: 150px;
    }
  }
  .buttonWrapper {
    display: flex;
    justify-content: flex-end;
    padding-top: 20px;
    ${CustomButton} {
      margin-left: 15px;
      :first-of-type {
        margin-left: 0;
      }
    }
  }
`;

export const CustomFadeInfo = styled(Fade)`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  /* min-width: 40%; */
  width: 400px;
  max-width: 90%;
  padding: 20px 30px;
  border-radius: 6px;
  background-color: ${Colors.darkSemiBg};
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 50px;
    h2 {
      padding-top: 40px;
      font-weight: 600;
      font-size: 24px;
      line-height: 30px;
      color: ${Colors.lightWhite};
    }
    p {
      font-size: 14px;
      line-height: 20px;
      padding-top: 15px;
      text-align: center;
      color: ${Colors.darkWhite};
    }
    ${CustomButton} {
      margin-top: 50px;
      width: 100%;
    }
    .buttonWrapper {
      display: flex;
      align-items: center;
      width: 100%;
      /* >* {
        margin-left: 20px;
      }
      :first-child {
        margin-left: 0;
      } */
      ${CustomButton} {
        margin-top: 50px;
        & + ${CustomButton} {
          margin-left: 20px;
        }
      }
    }
  }
`;

export const ChartWrapper = styled.div`
  background: linear-gradient(
    180deg,
    ${Colors.darkLightBg} 0%,
    ${Colors.darkSemiBg} 100%
  );
  border-radius: 28px;
  height: ${(props) => props.height || "500px"};
  padding: 24px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  position: relative;
  overflow: hidden;

  /* Arka plana çok hafif turkuaz bir parıltı */
  &::before {
    content: "";
    position: absolute;
    top: -10%;
    left: -10%;
    width: 300px;
    height: 300px;
    background: rgba(0, 242, 255, 0.03);
    filter: blur(80px);
    border-radius: 50%;
    pointer-events: none;
  }
  /* MOBİL AYARLAR */
  @media (max-width: 768px) {
    height: 380px; /* Mobilde daha makul bir yükseklik */
    padding: 15px;
    border-radius: 16px;
  }
`;

export const MobileMoreMenu = styled(Menu)`
  .MuiPaper-root {
    background-color: ${Colors.darkLightBg} !important;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 16px !important;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5) !important;
    min-width: 200px !important;
    padding: 6px !important;
  }
`;

export const MobileMoreMenuItem = styled(MenuItem)`
  display: flex !important;
  align-items: center !important;
  gap: 12px !important;
  padding: 10px 15px !important;
  border-radius: 10px !important;
  margin-bottom: 2px !important;
  transition: all 0.2s ease !important;

  span {
    color: ${Colors.darkWhite};
    font-size: 14px;
    font-weight: 600;
  }

  svg {
    font-size: 20px;
    color: ${Colors.darkWhite};
  }

  &:hover {
    background-color: rgba(0, 242, 255, 0.1) !important;
    span {
      color: #00f2ff !important;
    }
    svg {
      color: #00f2ff !important;
    }
  }
`;

export const TransferWrapper = styled.div`
  .MuiButton-root {
    padding: 3px 9px;
    font-size: 0.8125rem;
    color: ${Colors.darkWhite};
    border-color: ${Colors.darkWhite};
  }
  button + button {
    margin-top: 4vh;
  }
  .MuiPaper-elevation1 {
    box-shadow: none;
    border: 1px solid ${Colors.darkWhite};
  }
`;

export const CustomDialog = styled.div`
  /* width: clamp(320px, 40%, 90%); */
  padding: 30px;
  h2 {
    color: ${Colors.ligthWhite};
    padding-bottom: 20px;
  }
  .content {
    > * + * {
      margin-top: 20px;
    }
  }
  .buttonWrapper {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin: -5px -10px;
    padding-top: 20px;
    > * {
      margin: 5px 10px;
    }
  }
`;

export const CustomPopperUser = styled(Popper)`
  z-index: 1000;
  padding-top: 10px;

  .MuiPaper-root {
    background-color: ${Colors.darkLightBg};
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
    min-width: 180px;
    overflow: hidden;
    padding: 8px;
  }

  button {
    border-radius: 10px !important;
    justify-content: flex-start !important;
    font-weight: 600 !important;
    color: rgba(255, 255, 255, 0.7) !important;
    padding: 10px 15px !important;

    &:hover {
      background: rgba(0, 242, 255, 0.1) !important;
      color: #00f2ff !important;
      svg {
        color: #00f2ff !important;
      }
    }

    svg {
      margin-right: 10px;
      font-size: 20px;
    }
  }
`;

export const WebPageWrapper = styled.div``;

export const PaymentPage = styled.div`
  padding: 16px;
  h3 {
    color: ${Colors.white};
    font-size: 20px;
  }
  .inputArea {
    display: flex;
    padding: 25px 0;
    gap: 15px;
    align-items: flex-end;
    > .MuiFormControl-root {
    }
    p {
      color: ${Colors.white};
      min-width: 300px;
    }
  }
`;

// Arama Kutusu Konteynırı
export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  background: ${Colors.darkLightBg};
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  padding: 4px 4px 4px 16px;
  transition: all 0.3s ease;
  width: 100%;
  max-width: 450px;

  &:focus-within {
    border-color: #00f2ff;
    box-shadow: 0 0 15px rgba(0, 242, 255, 0.1);
  }

  input {
    background: transparent;
    border: none;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    width: 100%;
    outline: none;
    padding: 10px 0;
    &::placeholder {
      color: rgba(255, 255, 255, 0.3);
    }
  }
`;

// Modern Arama Butonu
export const ActionButton = styled.button`
  background: ${(props) =>
    props.active ? "#00F2FF" : "rgba(0, 242, 255, 0.1)"};
  color: ${(props) => (props.active ? Colors.darkBg : "#00F2FF")};
  border: none;
  border-radius: 10px;
  padding: 8px 20px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;

  &:hover {
    background: #00f2ff;
    color: ${Colors.darkBg};
    box-shadow: 0 5px 15px rgba(0, 242, 255, 0.3);
  }

  svg {
    font-size: 18px;
  }
`;

// Filtre Butonları (Chip Stili)
export const FilterChip = styled.button`
  background: ${(props) =>
    props.isSelected ? "rgba(0, 242, 255, 0.15)" : "rgba(255, 255, 255, 0.03)"};
  color: ${(props) =>
    props.isSelected ? "#00F2FF" : "rgba(255, 255, 255, 0.5)"};
  border: 1px solid
    ${(props) => (props.isSelected ? "#00F2FF" : "rgba(255, 255, 255, 0.1)")};
  padding: 8px 18px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover {
    border-color: #00f2ff;
    color: #00f2ff;
    background: rgba(0, 242, 255, 0.05);
  }

  ${(props) =>
    props.isSelected &&
    `
    box-shadow: 0 0 10px rgba(0, 242, 255, 0.2);
  `}
`;

export const PackageBadge = styled.div`
  display: flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.2s ease;
  cursor: help;
  white-space: nowrap;

  /* Duruma göre dinamik renkler */
  background: ${
    (props) =>
      props.isExpired
        ? "rgba(255, 76, 76, 0.1)" // Süresi dolmuş: Soft Kırmızı
        : "rgba(0, 242, 255, 0.1)" // Aktif: Turkuaz
  };

  color: ${(props) => (props.isExpired ? "#FF4C4C" : "#00F2FF")};

  border: 1px solid
    ${(props) =>
      props.isExpired ? "rgba(255, 76, 76, 0.2)" : "rgba(0, 242, 255, 0.2)"};

  &:hover {
    transform: translateY(-1px);
    background: ${(props) =>
      props.isExpired ? "rgba(255, 76, 76, 0.2)" : "rgba(0, 242, 255, 0.2)"};
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  }
`;

export const StatusPill = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 12px;
  border-radius: 20px; /* Tam yuvarlak köşeler */
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 1px;
  min-width: 80px;
  transition: all 0.2s ease;

  /* Aktif (value false iken) */
  background: ${(props) =>
    props.isActive ? "rgba(0, 255, 133, 0.1)" : "rgba(255, 76, 76, 0.1)"};

  color: ${
    (props) =>
      props.isActive
        ? "#00FF85" /* Canlı Yeşil */
        : "#FF4C4C" /* Soft Kırmızı */
  };

  border: 1px solid
    ${(props) =>
      props.isActive ? "rgba(0, 255, 133, 0.25)" : "rgba(255, 76, 76, 0.25)"};

  /* Hafif bir parlama efekti */
  box-shadow: ${(props) =>
    props.isActive ? "0 0 10px rgba(0, 255, 133, 0.1)" : "none"};

  &:hover {
    transform: scale(1.05);
    background: ${(props) =>
      props.isActive ? "rgba(0, 255, 133, 0.2)" : "rgba(255, 76, 76, 0.2)"};
  }
`;

export const StatusIconBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 10px; /* Modern yumuşak kare */
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  /* Duruma göre dinamik renkler */
  background: ${
    (props) =>
      props.isSuccess
        ? "rgba(0, 242, 255, 0.1)" // Başarılı: Hafıza Merkezi Turkuazı
        : "rgba(255, 76, 76, 0.1)" // Hata: Soft Kırmızı
  };

  border: 1px solid
    ${(props) =>
      props.isSuccess ? "rgba(0, 242, 255, 0.2)" : "rgba(255, 76, 76, 0.2)"};

  svg {
    font-size: 18px;
    fill: ${(props) => (props.isSuccess ? "#00F2FF" : "#FF4C4C")};
    /* Material UI ikonları için bazen path rengi gerekir */
    path {
      fill: ${(props) => (props.isSuccess ? "#00F2FF" : "#FF4C4C")};
    }
  }

  &:hover {
    transform: scale(1.1)
      rotate(${(props) => (props.isSuccess ? "0deg" : "10deg")});
    background: ${(props) =>
      props.isSuccess ? "rgba(0, 242, 255, 0.2)" : "rgba(255, 76, 76, 0.2)"};
    box-shadow: 0 4px 12px
      ${(props) =>
        props.isSuccess ? "rgba(0, 242, 255, 0.2)" : "rgba(255, 76, 76, 0.2)"};
  }
`;
